<template>
	<div class="createorder" ref="createorder">
		<el-form ref="createorderform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto'}">
			<el-row>
				<el-col v-for="(item, index) in model1" :span="24" v-if="item.l_mode == '渠道' && clearancelist.length > 1" :key="index">
					<el-card class="box-card" label="选择渠道" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_name }}</span>
						</div>
						<div>
							<el-select size="mini" v-model="checkedpmode" style="width:200px">
								<el-option v-for="(i, idx) in item.colsource" :key="i.d_name" :label="i.d_name" :value="i.d_name"></el-option>
							</el-select>
							<label style="margin-left:10px;font-size:10pt;">
								
							</label>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="12" v-if="(item.l_mode == '寄件人信息' || item.l_mode == '收件人信息') && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.l_mode" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_name }}</span>
						</div>
						<div class="inputBox">
							<el-form-item
								v-if="i.ishidden == 'False'"
								:class="['inputItem', i.controltype == 'textarea' || i.controltype == 'znsplit' ? 'col24' : 'col12']"
								:label="i.showname"
								label-width="80px"
								v-for="(i, idx) in item.children"
								:key="idx"
								size="mini"
							>
								<el-input
									v-if="i.controltype == 'text' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									:ref="i.colname"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								></el-input>
								<el-input
									v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									type="text"
									v-model="i.value"
									:ref="i.colname"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								></el-input>
								<el-autocomplete
									:ref="i.colname"
									v-if="i.controltype == 'input_filter'"
									v-model="i.value"
									:fetch-suggestions="
										(queryString, cb) => {
											inputsuggestions(queryString, cb, i, index);
										}
									"
									:style="{ width: `${i.coltdwidth}px` }"
									value-key="showname"
									:trigger-on-focus="true"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
									@select="
										val => {
											handleSelect(val, i, index);
										}
									"
								></el-autocomplete>
								<!-- 地址联动 -->
								<el-select
									:ref="i.colname"
									v-model="i.value"
									filterable
									remote
									reserve-keyword
									placeholder="可输入关键词搜索"
									:remote-method="val => addrinput(val, i, index)"
									:loading="loading"
									v-if="i.controltype == 'addrinput' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								>
									<el-option disabled label="可输入关键词搜索" value=""></el-option>
									<el-option v-for="item in i.colsource" :key="item.showname" :label="item.showname" :value="item.showname"></el-option>
								</el-select>

								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									class="input-with-search"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								>
									<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index, idx)">
										<span style="padding:15px"><i class="el-icon-search"></i></span>
									</div>
								</el-input>

								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
									:type="i.controltype"
									v-model="i.value"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								></el-input>
								<div v-if="i.controltype == 'znsplit' && i.ishidden == 'False'" class="textare_with_button">
									<el-input type="textarea" v-model="i.value" @keyup.native="val => enterinput(val, i, index)"></el-input>
									<el-button size="mini" type="warning" @click="znsplit(i, index, idx)">智能解析</el-button>
								</div>
								<el-select
									:ref="i.colname"
									v-model="i.value"
									filterable
									remote
									reserve-keyword
									placeholder="可输入关键词搜索"
									:remote-method="val => remoteMethod(val, i, index)"
									:loading="loading"
									v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@change.native="val => text_change(val, i, index)"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option disabled label="可输入关键词搜索" value=""></el-option>
									<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
								</el-select>
								<!-- @change.native="val => text_change(val, i, index)" -->
								<el-select
									:ref="i.colname"
									v-model="i.value"
									v-if="i.controltype == 'select' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
								<!-- :style="{width:`${i.coltdwidth}px`}" -->
								<el-checkbox
									v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
									:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
									:checked="i.coldefault == 1 ? true : false"
									@change="val => setcheck(val, i)"
								></el-checkbox>

								<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
							</el-form-item>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :span="24" :key="index" v-if="item.l_mode == '包裹信息' && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.showname" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_name }}</span>
						</div>
						<div>
							<el-row style="margin-top:-20px">
								<el-col v-for="(i, idx) in item.children" :key="idx" :span="i.controltype == 'table' ? 24 : 8">
									<tableui
										ref="cargo"
										editcell="1"
										v-if="i.controltype == 'table' && i.ishidden == 'False'"
										:tableData="orderinfo.cargolist"
										:columns="i.table"
										@gridhandle="gridhandle"
										@autoaddrow="gridhandle"
										:gridheight="gridheight"
										@setuparrow="setuparrow"
									></tableui>
									<el-form-item
										v-if="
											(i.controltype == 'text' || 'textarea' || 'select' || 'checkbox' || 'combox-checkbox') &&
												i.controltype != 'table' &&
												i.ishidden == 'False'
										"
										:label="i.showname"
										label-width="80px"
										size="mini"
									>
										<el-input
											:ref="i.colname"
											v-model="i.value"
											type="i.controltype"
											:style="{ width: `${i.coltdwidth}px` }"
											v-if="(i.controltype == 'text' || i.controltype == 'textarea') && i.ishidden == 'False'"
											@keyup.native="val => enterinput(val, i, index)"
										></el-input>
										<el-select
											:ref="i.colname"
											v-model="i.value"
											v-if="i.controltype == 'select' && i.ishidden == 'False'"
											:style="{ width: `${i.coltdwidth}px` }"
											@keyup.native="val => enterinput(val, i, index)"
										>
											<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
										</el-select>
										<label v-if="i.controltype == 'checkbox' && i.ishidden == 'False'">
											<el-checkbox
												:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
												v-model="i.value"
												:true-label="1"
												:false-label="0"
												:checked="i.value == '1' ? true : false"
											></el-checkbox>
										</label>
										<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
											<el-checkbox
												:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
												true-label="1"
												false-label="0"
												:checked="i.value != '' && i.value != '0.00' ? true : false"
											></el-checkbox>
										</div>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="24" v-if="item.l_mode == '附加信息' && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.l_mode" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_name }}</span>
						</div>
						<div class="inputBox">
							<el-form-item
								:class="['inputItem', 'col12']"
								:label="i.showname"
								label-width="80px"
								v-for="(i, idx) in item.children"
								:key="idx"
								v-if="i.ishidden == 'False'"
								size="mini"
							>
								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'text' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									@keyup.native="val => enterinput(val, i, index)"
								></el-input>
								<el-input :ref="i.colname" v-if="i.controltype == 'textarea' && i.ishidden == 'False'" :type="i.controltype" v-model="i.value"></el-input>
								<el-select :ref="i.colname" v-if="i.controltype == 'select' && i.ishidden == 'False'" v-model="i.value" :style="{ width: `${i.coltdwidth}px` }">
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
								<el-checkbox
									v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
									:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
									v-model="i.coldefault"
									:checked="i.coldefault == 1 ? true : false"
								></el-checkbox>
								<div v-else-if="i.controltype=='checkbox_radio_link'">
									<el-checkbox
										:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '',marginRight:'30px' }"
										:ref="i.colname + '_checked'"
										true-label="1"
										false-label="0"
										@change="val => checkchange(val, i.colname, i)"
									></el-checkbox>
									 <el-radio-group v-model="i.value" :ref="i.colname" :style="{marginLeft: `10px`,display:`none`}">
									    <el-radio v-for="(source, idx) in i.colsource" :key="idx" :label="source.title">{{source.title}}</el-radio>
									 </el-radio-group>
								</div>
								<div v-else-if="i.controltype == 'combox-checkbox_notips' && i.ishidden == 'False'">
									<el-checkbox
										:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
										true-label="1"
										false-label="0"
										:ref="i.colname + '_checked'"
										:checked="i.value != '' && i.value != '0.00' ? true : false"
										@change="val => checkchange(val, i.colname, i)"
									></el-checkbox>
									<el-input
										:style="{
											width: `${i.coltdwidth}px`,
											marginLeft: `10px`,
											display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}`
										}"
										:ref="i.colname"
										type="text"
										v-model="i.value"
										@keyup.native="val => enterinput(val, i, index)"
									></el-input>
								</div>
								<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
								<el-select v-model="i.value" multiple v-else-if="i.controltype=='select_multiple'&& i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }" >
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveorder">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="reback">返回</div></el-col>
		</el-row>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="600px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col :span="3" style="color:transparent">1</el-col>
				<el-col :span="18" style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;" v-if="errorfile == '' && errormessage == ''"></i>
					<i class="el-icon-error" style="color:#e27b20;font-size:55pt;" v-if="errorfile != '' || errormessage != ''"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold" v-if="errormessage != '' && isbig">{{ errormessage }}</span>
					<span style="font-size:12pt;font-weight: bold" v-if="errormessage != '' && !isbig">{{ errormessage }}</span>
					<span style="font-size:20pt;font-weight: bold" v-if="errormessage == ''">保存成功</span>
				</el-col>
				<el-col :span="1" style="color:transparent">1</el-col>
			</el-row>
			<el-row v-if="errorfile == '' && errormessage == ''">
				<el-col :span="24" style="text-align:center;">
					<div>
						<el-divider>选择邮寄到仓库方式</el-divider>
						<div>
							<el-button round icon="el-icon-position" class="orange" type="warning" size="medium" @click="successfun(4)">在线寄件</el-button>
							<el-button round icon="el-icon-phone" class="purple" type="warning" size="medium" @click="successfun(5)">自行邮寄</el-button>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="errorfile == ''" style="margin-top:50px;">
				<el-col :span="4" style="color:transparent">1</el-col>
				<el-col :span="7"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="5"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="4" style="text-align:center;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row v-if="errorfile != ''" style="margin-top:50px;">
				<el-col :span="6"><el-button type="danger" size="medium" @click="downfile">失败详情</el-button></el-col>
				<el-col :span="8"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="6"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="4" style="text-align:center;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
		<el-dialog :visible.sync="showaddrwin" title="地址簿" width="600px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<addresslist
				:type="addrtype"
				:addrsearchkey="addrsearchkey"
				:modelindex="modelindex"
				:childrenindex="childrenindex"
				ref="addresslist"
				@rebackaddr="rebackaddr"
			></addresslist>
		</el-dialog>
		<el-dialog :visible.sync="showcargolistwin" title="选择商品" width="95%" :close-on-click-modal="false" lock-scroll :append-to-body="true" :show-close="false">
			<cargolist ref="selectcargo" :urlparam="cargoparam"></cargolist>
			<span slot="footer" class="dialog-footer">
				<div style="text-align: center;width:100%">
					<el-button size="mini" type="success" @click.native="surecargo">确定</el-button>
					<el-button size="mini" type="info" plain @click.native="closecargo">关闭</el-button>
				</div>
			</span>
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
		<BatchUpdate ref="BatchUpdate"></BatchUpdate>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import addresslist from '@/components/address/addresslist.vue';
import printhandler from '@/components/order/printhandler.vue';
import cargolist from '@/pages/baseinfo/cargolist';
import BatchUpdate from '@/components/order/BatchUpdate.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		addresslist,
		printhandler,
		cargolist,
		BatchUpdate
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		},
		curpkval: {
			type: String,
			default: ''
		},
		iscopy: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 150,
			gridheight: '260px',
			model1: [],
			btndisabled: false,
			pkval: '', //修改时此值不为空
			p_pkval: '',
			cargolist: [],
			orderinfo: {},
			loading: false,
			//gridheight: (window.innerHeight * 50) / 100 + 'px',
			showaddrwin: false,
			addrtype: '0', //地址标识 1-寄件地址 0-收件地址
			modelindex: -1,
			childrenindex: -1,
			addrsearchkey: '',
			type:'默认',
			showsuccesswin: false,
			addressinfo: '', //默认寄件地址
			vipaccount: '',
			errormessage: '',
			errorfile: '',
			gridrowindex: -1,
			gridcolindex: -1,
			divclass: 'createorder',
			showcargolistwin: false,
			cargoparam: {}, //选择商品
			isbig: true,
			chooseclearanceindex: 0,
			clearancelist: [],
			checkedpmode: '',
			p_mode: ''
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/haitaomanager/createorder.scss');		
		if (this.iscopy == 1) this.p_pkval = '';
		var that = this;
		this.vipaccount = localStorage.getItem('vipaccount');
	},
	methods: {
		init(param) {
			debugger
			this.$tool.loading('正在加载', this.divclass);
			//debugger
			this.GetDefaultaddr();
		},
		//获取默认寄件地址
		GetDefaultaddr() {
			var that = this;
			this.$apipost.get.GetDefaultCtaddr().then(res => {
				if (res.addressinfo != undefined && res.addressinfo != '') {
					that.addressinfo = res.addressinfo;
				}
				this.GetClarance(-1);
			});
		},
		//排版
		GetPageLayout() {
			var that = this;
			if (that.curpkval != '') {
				this.$apipost.get.GetOrderInfo({ pkval: that.curpkval }).then(order => {
					if (order != '') {
						if (that.iscopy == 1) {
							that.pkval = '';
						} else {
							that.pkval = that.curpkval;
						}
						that.orderinfo = order.orderinfo;
						that.GetPageLayoutSet();
					}
				});
			} else {
				that.GetPageLayoutSet();
			}
		},
		//获取排版信息
		GetPageLayoutSet() {
			var that = this;
			this.$apipost.get.CreatePageLayoutByPmode({ sys: '出口系统', fun: '海淘下单', type: this.type, p_mode: '' }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.list.length > 0) {
						that.model1 = [];
						that.SetPageLayout(res.list);
					}
				}
			});
		},
		//设置排版
		SetPageLayout(list) {
			//debugger
			var index = 0;
			var that = this;
			var isorderinfo = true;
			if (that.orderinfo.p_pkval == undefined) {
				//说明未获取到订单信息
				isorderinfo = false;
			}
			that.model1 = list;
			list.forEach(e => {
				if (e.ishidden == 'False') {
					if (e.l_mode == '渠道') {
						that.GetClarance(index);
					}
					if (e.l_mode == '包裹信息') {
						e.children.forEach(cargo => {
							if (cargo.controltype == 'table' && cargo.ishidden == 'False') {
								//console.log('table',cargo.table);
								that.setcargocol(cargo.table);
								if (isorderinfo) {
									if (that.orderinfo.cargolist != undefined) that.cargolist = that.orderinfo.cargolist;
								}
								//return false;
							} else {
								if (isorderinfo) {
									if (cargo.controltype == 'combox-input' && cargo.ishidden == 'False') {
										var volume = cargo.combox;
										cargo.combox.forEach(com => {
											for (var key in that.orderinfo.baginfo) {
												if (com.colname == key) {
													com.value = that.orderinfo.baginfo[key];
												}
											}
										});
									} else {
										if (cargo.ishidden == 'False') {
											for (var key in that.orderinfo.baginfo) {
												if (cargo.colname == key) {
													cargo.value = that.orderinfo.baginfo[key];
												}
											}
										}
									}
								}
							}
						});
					}
					if (e.l_mode == '寄件人信息') {
						if (isorderinfo) {
							e.children.forEach(sender => {
								if(that.iscopy==3){
									if (that.addressinfo != '') {
										var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
										for (var key in addressinfo) {
											if (sender.colname == key) {
												sender.value = addressinfo[key];
											}
											if (sender.value == '' || sender.value == undefined) {
												sender.value = sender.coldefault;
											}
										}
									} else {
										sender.value = sender.coldefault;
									}
								}else{
									for (var key in that.orderinfo.sender) {
										if (sender.colname == key) {
											sender.value = that.orderinfo.sender[key];
											if (sender.value == '' || sender.value == undefined) {
												sender.value = sender.coldefault;
											}
										}
									}
								}
							});
						} else {
							e.children.forEach(sender => {
								if (that.addressinfo != '') {
									var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
									for (var key in addressinfo) {
										if (sender.colname == key) {
											sender.value = addressinfo[key];
										}
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								} else {
									sender.value = sender.coldefault;
								}
							});
						}
					}
					if (e.l_mode == '收件人信息') {
						if (isorderinfo) {
							e.children.forEach(receiver => {
								for (var key in that.orderinfo.receiver) {
									if (receiver.colname == key) {
										receiver.value = that.orderinfo.receiver[key];
										if (receiver.value == '' || receiver.value == undefined) {
											receiver.value = receiver.coldefault;
										}
									}
								}
							});
						} else {
							e.children.forEach(receiver => {
								if (receiver.value == '' || receiver.value == undefined) {
									receiver.value = receiver.coldefault;
								}
							});
						}
					}
					if (e.l_mode == '附加信息') {
						if (isorderinfo) {
							e.children.forEach(orderextend => {
								for (var key in that.orderinfo.extend) {
									if (orderextend.colname == key) {
										orderextend.value = that.orderinfo.extend[key];
									}
								}
							});
						}
					}
				}
				index++;
			});
		},
		GetClarance(index) {
			var that = this;
			if (index > -1) {
				// if (that.clearancelist.length <= 1) {
				// 	that.model1[index].ishidden = 'True';
				// }
				if (that.pkval != undefined && that.pkval != '') {
					//表示修改
					that.p_mode = that.orderinfo.p_mode + ',' + that.orderinfo.mode; //并且设置当前加载的项目为选中状态
				} else {
					if (that.p_mode == '') that.p_mode = that.clearancelist[0].d_name + ',' + that.clearancelist[0].d_value;
				}
				that.model1[index].colsource = that.clearancelist;
				var list = that.clearancelist;
				for (var i = 0; i < list.length; i++) {
					if (list[i].d_name + ',' + list[i].d_value == that.p_mode) {
						that.chooseclearanceindex = i;
						break;
					}
				}
			} else {
				this.$apipost.get.GetClarance().then(res => {
					that.clearancelist = res.list;
					if (that.clearancelist.length > 0) {
						that.checkedpmode = that.clearancelist[0].d_name;
					}
					that.GetPageLayout();
				});
			}
		},
		//根据界面布局，设置包裹信息列
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargorow = JSON.parse(cargo)[0];
			if (this.orderinfo.p_pkval == undefined) 
				this.orderinfo.cargolist = JSON.parse(cargo);
		},
		//删除行
		deleteRow(e) {
			this.orderinfo.cargolist.splice(e.index, 1);
			if (this.orderinfo.cargolist.length < 1) {
				this.orderinfo.cargolist.push(JSON.parse(JSON.stringify(this.cargorow)));
			}
		},
		setuparrow() {
			this.enterinput({ keyCode: 37 }, { colperv: 'storehouse' }, '');
		},
		//智能拆分
		znsplit(i, modelindex, childrenindex) {
			this.modelindex = modelindex;
			//this.childrenindex=childrenindex;
			var address = i.value;
			var that = this;
			//开始解析
			this.$apipost.get.SplitAddr({ addrinfo: address }).then(res => {
				if (res != '') {
					this.model1[modelindex].children.forEach(item => {
						if (item.colname == 'cgname') item.value = res.name;
						if (item.colname == 'cgphone') item.value = res.phone;
						if (item.colname == 'cgpostcode') item.value = res.postcode;
						if (item.colname == 'cgprovince') item.value = res.provice;
						if (item.colname == 'cgcity') item.value = res.city;
						if (item.colname == 'cgdistrict') item.value = res.district;
						if (item.colname == 'cgdetailaddr') item.value = res.detailaddr;
						if (item.colname == 'cgidcard') item.value = res.idcard;
					});
				}
			});
		},
		//列表操作事件
		gridhandle(e) {
			var that = this;
			if (e.event == 'addrow') {
				this.orderinfo.cargolist.splice(e.index + 1, 0, JSON.parse(JSON.stringify(this.cargorow)));
			}
			if (e.event == 'delrow') {
				this.deleteRow(e);
			}
			if (e.event == 'getcargo') {
				this.GetCargo(e, false); //获取商品基本信息
			}
		},
		//获取商品勾选行
		GetCargo(e, iscallback) {
			//获取商品信息
			var that = this;
			var storehouse = '';
			if (this.$refs.storehouse != undefined) storehouse = this.$refs.storehouse[0]._data.selected.currentLabel;
			if (storehouse == '') {
				this.$tool.message('请选择所属仓库', 0);
				return false;
			}
			var rowindex = e.index;
			var colindex = e.colindex;
			this.gridrowindex = rowindex;
			this.gridcolindex = colindex;
			var search = new Object();
			search.storehouse = storehouse;
			if (iscallback) {
				search = JSON.parse(e.search);
			} else {
				var field = e.field;
				search[field] = this.orderinfo.cargolist[rowindex][field];
			}
			var paraminfo = {
				search: JSON.stringify(search),
				pageindex: 0,
				pagesize: 200,
				sort: '',
				tab: 'tab1',
				l_mode: '商品库管理',
				showcol: '',
				userid: localStorage.getItem('userid')
			};
			// console.log('商品',escape(JSON.stringify(paraminfo)));
			// return false;
			this.$tool.loading('正在获取商品', this.divclass);
			this.$apipost.get.GetBaseCargoList({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				//console.log('商品信息',res,);
				if (res.count == 1) {
					that.addcargorow(res.data);
				} else {
					if (iscallback) {
						if (res.count > 1)
							//根据返回内容回填到列表
							that.addcargorow(res.data, true);
					} else {
						//弹出选择框
						that.showcargolistwin = true;
						that.cargoparam = {
							searchlist: search,
							storehouse: storehouse,
							type: 'select'
						};
						if (that.$refs.selectcargo != undefined) that.$refs.selectcargo.init(that.cargoparam);
					}
				}
			});
		},
		//确认选择
		surecargo() {
			//debugger;
			if (this.$refs.selectcargo.selectedall) {
				if (this.$refs.selectcargo.cargolist.length > 0)
					this.GetCargo({ search: this.$refs.selectcargo.GetSearchObj(), index: this.gridrowindex, colindex: this.gridcolindex }, true);
			} else {
				if (this.$refs.selectcargo.checkedrow.length > 0) this.addcargorow(this.$refs.selectcargo.checkedrow, true);
			}
		},
		//填写行
		addcargorow(rows, isclose) {
			if (isclose == undefined) isclose = false;
			var that = this;
			var rowindex = this.gridrowindex;
			//判断新添加的商品是否已存在在已添加列表中，有则累加数量，没有则新增行
			that.orderinfo.cargolist.forEach(e => {
				var index = 0;
				rows.forEach(r => {
					if (r.id == e.id && e.id != '') {
						e.num = parseInt(e.num) + 1;
						//移除此行
						rows.splice(index, 1);
					}
					index++;
				});
			});
			rows.forEach(e => {
				if (rowindex > that.gridrowindex) that.orderinfo.cargolist.splice(rowindex, 0, JSON.parse(JSON.stringify(this.cargorow)));
				for (var key in that.orderinfo.cargolist[rowindex]) {
					for (var cargokey in e) {
						if (cargokey == key) {
							that.orderinfo.cargolist[rowindex][key] = e[key];
							break;
						}
					}
					if (key == 'num') that.orderinfo.cargolist[rowindex][key] = '1';
				}
				rowindex++;
			});
			if (isclose) this.closecargo();
			else {
				if (rows.length > 0) {
					this.$refs.cargo[0].setfoucsbyindex(this.gridrowindex, undefined, 'num');
				}
			}
		},
		//关闭选择商品
		closecargo() {
			this.showcargolistwin = false;
			if (this.orderinfo.cargolist[this.gridrowindex].id != undefined) this.$refs.cargo[0].setfoucsbyindex(this.gridrowindex, undefined, 'num');
		},
		//保存订单
		saveorder() {
			var that = this;
			var isgo = true;
			var orderinfo = {};
			orderinfo = that.getorderObj(JSON.parse(JSON.stringify(this.model1)), orderinfo, true);
			if (orderinfo.receiver != undefined) {
				this.$tool.loading('正在保存', this.divclass);
				//console.log('orderinfo',escape(JSON.stringify(orderinfo)));
				//return false;
				this.$apipost.post.SaveOrder({ orderinfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						that.showsuccesswin = true;
						if (res.state == '0') {
							if (res.message != '') {
								that.errormessage = res.message;
								if (that.errormessage.length > 15) that.isbig = false;
								else that.isbig = true;
							}
							if (res.filename != '' && res.filename != undefined) that.errorfile = res.filename;
						}else{
							that.p_pkval=res.pkval;
						}
					}
				});
			}
		},
		//获取订单实体信息
		getorderObj(model1, orderinfo, iserror) {
			var that = this;
			if (this.iscopy == 1) {
				this.pkval = '';
			}
			orderinfo = {
				u_userid: localStorage.getItem('userid'),
				u_account: localStorage.getItem('u_account'),
				u_name: localStorage.getItem('u_name'),
				u_company: localStorage.getItem('u_company'),
				pkval: this.pkval,
				p_pkval: this.p_pkval,
				p_sys: '海淘订单',
				tablename:'sp_pt_printlist_ls',
				p_mode:this.checkedpmode,
				iscopy:this.iscopy
			};
			var error = '';
			for (var i = 0; i < model1.length; i++) {
				if (error == '' || !iserror) {
					
					if (model1[i].l_mode == '寄件人信息' && model1[i].ishidden == 'False') {
						var sender = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写寄件人' + children[j].showname;
								if (iserror) {
									sender = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									sender += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								sender += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (sender != '') {
							sender = sender.replace(/\n/g, '');
							sender = '{' + sender.substring(0, sender.length - 1) + '}';
							orderinfo.sender = JSON.parse(sender);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '收件人信息' && model1[i].ishidden == 'False') {
						var receiver = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写收件人' + children[j].showname;
								if (iserror) {
									receiver = '';
									break;
								}
							}
							if(error == ''){
								if(children[j].isnull == 'False'&&children[j].coltype=='phone'){
									if(!that.$tool.checktel(children[j].value))
									{
										error = '请填写正确的' + children[j].showname;
										if (iserror) {
											sender = '';
											break;
										}
									}
								}
							}
							if(error == ''){
								if(children[j].isnull == 'False'&&children[j].coltype=='idcard'){
									if(!that.$tool.checkidcardformat(children[j].value))
									{
										error = '请填写正确的收件人' + children[j].showname;
										if (iserror) {
											sender = '';
											break;
										}
									}
								}
							}
							if (error == '') {
								if (children[j].ishidden == 'False') {
									receiver += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								receiver += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (receiver != '') {
							receiver = receiver.replace(/\n/g, '');
							receiver = '{' + receiver.substring(0, receiver.length - 1) + '}';
							orderinfo.receiver = JSON.parse(receiver);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '包裹信息') {
						var isnocargo = false;
						var baginfo = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype != 'table') {
								if (children[j].controltype == 'combox-input' && children[j].isnull == 'False') {
									var volume = children[j].combox;
									for (var k = 0; k < volume.length; k++) {
										if (volume[k].value == undefined) {
											volume[k].value = '';
										}
										if (volume[k].isnull == 'False' && volume[k].value == '') {
											error = '请填写' + volume[k].showname;
											if (iserror) {
												break;
											}
										}
										if (iserror) {
											if (volume[k].ishidden == 'False') baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
										} else {
											baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
										}
									}
									if (error != '') {
										if (iserror) {
											baginfo = '';
											break;
										}
									}
								} else {
									if (children[j].value == undefined) {
										children[j].value = '';
									}
									if((children[j].controltype == 'combox-checkbox_notips') && children[j].isnull == 'False'){
										//如果未勾选，则选定的值清空
										if(!that.$refs[children[j].colname+'_checked'][0].isChecked){
											children[j].value = '';
										}
									}
									if((children[j].controltype == 'combox-checkbox_notips') && children[j].isnull == 'False'){
										//debugger
										if (children[j].isnull == 'False' && children[j].value == '') {
											if(that.$refs[children[j].colname+'_checked'][0].isChecked){
												error = '请填写' + children[j].showname;
												if (iserror) {
													break;
												}
											}
											
										}
									}
									else{
										if (children[j].isnull == 'False' && children[j].value == '') {
											error = '请填写' + children[j].showname;
											if (iserror) {
												break;
											}
										}
									}
									if (iserror) {
										if (children[j].ishidden == 'False') baginfo += '"' + children[j].colname + '":"' + children[j].value + '",';
									} else {
										baginfo += '"' + children[j].colname + '":"' + children[j].value + '",';
									}
								}
							} else {
								if (children[j].ishidden == 'True') {
									isnocargo = true;
								}
							}
						}
						if (error == '' || !iserror) {
							if (baginfo != '') {
								baginfo = baginfo.replace(/\n/g, '');
								baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
								orderinfo.baginfo = JSON.parse(baginfo);
							}
							if (!isnocargo) {
								orderinfo.cargolist = that.orderinfo.cargolist;
							}
							if (that.orderinfo.cargolist.length == 0) {
								if (!isnocargo) error = '请填写包裹信息';
							} else {
								var content = '';
								that.orderinfo.cargolist.forEach(e => {
									if (e.cnameall != undefined) {
										content += e.cnameall + ' ' + e.num + '  ';
									} else {
										if (e.brand != undefined) {
											content += e.brand + ' ';
										}
										if (e.cname != undefined) {
											content += e.cname + ' ';
										}
										if (e.spec != undefined) {
											content += e.spec + ' ';
										}
										content += e.num + ' ';
										if (e.unit != undefined) {
											content += e.unit + ' ';
										}
									}
								});
								orderinfo.p_content = content;
							}
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '附加信息' && model1[i].ishidden == 'False') {
						var extend = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype == 'checkbox') {
								if (children[j].coldefault) {
									children[j].value = '1';
								} else {
									children[j].value = '0';
								}
							} else {
								if (children[j].value == undefined) {
									children[j].value = '';
								}
							}
							if((children[j].controltype == 'combox-checkbox_notips') && children[j].isnull == 'False'){
								//debugger
								if (children[j].isnull == 'False' && children[j].value == '') {
									if(that.$refs[children[j].colname+'_checked'][0].isChecked){
										error = '请填写' + children[j].showname;
										if (iserror) {
											break;
										}
									}
									
								}
							}else {
								if (children[j].isnull == 'False' && children[j].value == '') {
									error = '请填写' + children[j].showname;
									if (iserror) {
										extend = '';
										break;
									}
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									extend += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								extend += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (extend != '') {
							extend = extend.replace(/\n/g, '');
							extend = '{' + extend.substring(0, extend.length - 1) + '}';
							orderinfo.extend = JSON.parse(extend);
						}
					}
				}
				if (error != '' && iserror) {
					this.$tool.message(error, 0);
					break;
				}
			}
			if (error != '' && iserror) {
				orderinfo = {};
			}

			return orderinfo;
		},
		//远程搜索option（国家）
		remoteMethod(query, i) {
			var that = this;
			if (query != '') {
				setTimeout(function() {
					if (i.colname.indexOf('country') > 0) {
						that.$apipost.get.GetCountry({ searchkey: query }).then(res => {
							if (res != '') {
								i.colsource = res.list;
							}
						});
					}
				}, 100);
			}
		},
		//带搜索的输入框
		inputgroupsearch(i, modelindex, childrenindex) {
			if (i.colname == 'ctcompany' || i.colname == 'ctname') {
				//按公司名搜索地址库
				this.addrtype = '1';
			} else if (i.colname == 'cgcompany' || i.colname == 'cgname') {
				this.addrtype = '0';
			}
			this.modelindex = modelindex;
			this.childrenindex = childrenindex;
			this.addrsearchkey = i.value;
			if (this.$refs.addresslist != undefined) {
				this.$refs.addresslist.init({ type: this.addrtype, addresskey: i.value, modelindex: modelindex, childrenindex: childrenindex });
			}
			this.showaddrwin = true;
		},
		//选地址回填
		rebackaddr(e) {
			var that = this;
			this.model1[e.modelindex].children.forEach(item => {
				if (that.addrtype == '1') {
					if (item.colname == 'ctcompany') item.value = e.row.company;
					if (item.colname == 'ctname') item.value = e.row.name;
					if (item.colname == 'ctphone') item.value = e.row.phone;
					if (item.colname == 'ctpostcode') item.value = e.row.postcode;
					if (item.colname == 'ctcountry') item.value = e.row.country;
					if (item.colname == 'ctprovince') item.value = e.row.province;
					if (item.colname == 'ctcity') item.value = e.row.city;
					if (item.colname == 'ctdistrict') item.value = e.row.district;
					if (item.colname == 'ctdetailaddr') item.value = e.row.street + e.row.detailaddr;
					if (item.colname == 'ctidcard') item.value = e.row.idcard;
				} else {
					if (item.colname == 'cgcompany') item.value = e.row.company;
					if (item.colname == 'cgname') item.value = e.row.name;
					if (item.colname == 'cgphone') item.value = e.row.phone;
					if (item.colname == 'cgpostcode') item.value = e.row.postcode;
					if (item.colname == 'cgcountry') item.value = e.row.country;
					if (item.colname == 'cgprovince') item.value = e.row.province;
					if (item.colname == 'cgcity') item.value = e.row.city;
					if (item.colname == 'cgdistrict') item.value = e.row.district;
					if (item.colname == 'cgdetailaddr') item.value = e.row.street + e.row.detailaddr;
					if (item.colname == 'cgidcard') item.value = e.row.idcard;
				}
			});
			this.showaddrwin = false;
		},
		//操作完成
		successfun(type) {
			var that = this;
			that.showsuccesswin = false;
			if (type == 0) {
				//关闭
				this.reback();
			} else if (type == 1) {
				//保留界面上的信息，再下新单
				that.clearinput(false);
			} else if (type == 2) {
				//新增订单，清空界面上所有填写的
				that.clearinput(true);
			} else if (type == 4) {
				//下物流单
				// this.$apipost.get.GetLinkInfo({l_id: 71 }).then(res => {
				// 	if (res != '') {
				// 		that.reback();
				// 		//获取到寄件页面名称
				// 		Utils.$emit('go', {
				// 			l_url: '/logisticsmanager/createlogisticsorder',
				// 			l_name:res.info.l_name,
				// 			l_id: 71,
				// 			urlparam: { pkval: that.p_pkval, iscopy: 2 }
				// 		});
				// 	}
				// });
			}
			else if(type==5){
				if (that.$refs.BatchUpdate != undefined) {
					that.$refs.BatchUpdate.init({
						title:'自行邮寄',
						pageparam:that._data,
						pkval:that.p_pkval,
						pkcol:'p_pkval'
					});
				}
			}
		},
		clearinput(clearall) {
			var that = this;
			that.p_pkval = '';
			that.pkval = '';
			var model1 = that.model1;
			if (clearall) {
				for (var i = 0; i < model1.length; i++) {
					if (model1[i].l_mode == '寄件人信息' || model1[i].l_mode == '收件人信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].coldefault != '') children[j].value = children[j].coldefault;
							else children[j].value = '';
						}
						if (model1[i].l_mode == '寄件人信息') {
							if (that.addressinfo != '') {
								var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
								model1[i].children.forEach(sender => {
									for (var key in addressinfo) {
										if (sender.colname == key) {
											sender.value = addressinfo[key];
										}
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								});
							}
						}
					}
					if (model1[i].l_mode == '包裹信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype != 'table') {
								if (children[j].controltype == 'combox-input') {
									var volume = children[j].combox;
									for (var k = 0; k < volume.length; k++) {
										volume[k].value = '';
									}
								} else children[j].value = '';
							} else {
								that.cargolist = [];
							}
						}
					}
					if (model1[i].l_mode == '附加信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype == 'checkbox') {
								if (children[j].coldefault) {
									children[j].value = '1';
								} else {
									children[j].value = '0';
								}
							} else {
								children[j].value = '';
							}
						}
					}
				}
			}
		},
		//地址联动选择
		addrinput(val, i, modelindex) {
			this.$tool.addrlink(this, val, modelindex, i);
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.addrlink_call(this, modelindex, i, cb);
			}
		},
		//选中提示选项时
		handleSelect(item, i, modelindex) {
			var that = this;
		},
		//文本框改变
		text_change(val, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.addrlink(this, val, modelindex, i);
			} else {
				//debugger;
			}
		},
		enterinput(event, i, modelindex) {
			//console.log(val);
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid') this.$refs.cargo[0].setgridfoucs();
						else this.$refs[i.colnext][0].focus();
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		reback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		downfile() {
			this.$tool.downfile(this, this.errorfile, '');
		},
		checkchange(val, control, i) {
			//debugger
			if (val == '1'||val==true) {
				if(i.controltype=='checkbox_radio_link'){
					if(i.value=='')
						i.value=i.colsource[0].title;
				}
				this.$refs[control][0].$el.style.display = 'inline-block';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'inline-block';
				}
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'inline-block';
				}
			} else {
				if (i != undefined) i.value = '';
				this.$refs[control][0].$el.style.display = 'none';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'none';
				}
			}
		},
	}
};
</script>
